module.exports = ".checkboxlabel{\n    margin-left: 10px;\n padding-top: -52rem;\n margin-top: -0.2rem;\n}\n\n.checkboxSize{\n    zoom:1.8;\n}"